import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bonus'
})
export class BonusPipe implements PipeTransform {
  transform(
    value: any,
    sco?: any,
    typeGame?: string,
    quotaTotal?: number,
    pun?: number,
    comb?: number
  ): any {
    if (!value) {
      return null;
    }
    switch (typeGame) {
      case 'single': {
        value = value.filter(x => x.min === 1);
        value = value.filter(x => x.balance >= sco.reduce((z, y) => z + y.extra.amount, 0) * 100);
        // value = value.filter(x => args.every(y => Number(y.quo) >= x.minOdd));
        value = value.filter(x => sco.every(y => Number(y.quo) >= x.minodd || Number(y.quo) >= x.minOdd));

        if (sco.length !== 1) {
          value = value.filter(x => x.total === 0);
        }
        break;
      }
      case 'multiple': {
        value = value.filter(x => x.balance >= pun);
        // value = value.filter(x => Number(x.minOdd) <= args3 * 100);
        value = value.filter(x => Number(x.minodd) <= quotaTotal * 100 || Number(x.minOdd) <= quotaTotal * 100);
        value = value.filter(x => Number(x.min) <= sco.length && Number(x.max) >= sco.length);
        break;
      }
      case 'sistemi': {
        value = value.filter(x => x.balance >= pun);
        // value = value.filter(x => Number(x.minOdd) <= args3 * 100);
        value = value.filter(x => Number(x.minodd) <= quotaTotal * 100 || Number(x.minOdd) <= quotaTotal * 100);
        value = value.filter(x => Number(x.min) <= sco.length && Number(x.max) >= sco.length);
        break;
      }
      case 'system': {
        if (comb && comb > 0) {
          value = value.filter(x => x.balance >= pun);
          // value = value.filter(x => Number(x.minOdd) <= args3);
          value = value.filter(x => Number(x.minodd) <= quotaTotal || Number(x.minOdd) <= quotaTotal);
          value = value.filter(x => Number(x.min) === 1);
        } else {
          value = [];
        }
        break;
      }
    }

    if (value.length > 0) {
      return value;
    } else {
      return null;
    }
  }
}
